<template>
  <div
    class="question center-cover vh-xs-100 overflow-y-scroll"
    v-bind:style="{'background-image': `url(${settings.background_url})`}"
  >
    <div class="pt-sm-5 pt-0 pb-sm-5 pb-0 d-flex
    align-items-center justify-content-center">
      <QuestionCompletedBlock></QuestionCompletedBlock>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import QuestionCompletedBlock from '@/components/QuestionCompletedBlock.vue';

export default {
  name: 'loginregistration',
  components: { QuestionCompletedBlock },
  data() {
    return { settings: { background_url: 'https://bangerhead-test-api.s3.eu-north-1.amazonaws.com/media/bangerhead_2_8xkpDkX.jpg' } };
  },
};
</script>
